import React from 'react';
import { MdDownload, MdEdit } from 'react-icons/md';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';

import PayablesDropDown from '../../../ConstructionsDetails/payables/PayableDropDown/PayablesDropDown';

import {
  BtnSecondaryStyled,
  BtnStyled,
  DefaultPageStyled,
  RootStyled,
  TableCellHeaderStyled,
  TableRowBodyStyled,
} from './index.styles';

import {
  MOCK_HEADER_INFO,
  MOCK_BUDGETS,
} from '../../../../../../../services/driverJS/mocks';

export function TourBudgets() {
  return (
    <Paper style={{ minHeight: 440 }}>
      <RootStyled>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <Typography style={{ fontSize: '24px' }} variant="h1">
              Obra Tour
            </Typography>
            <div style={{ marginTop: 16 }}>
              <PayablesDropDown headerInfo={MOCK_HEADER_INFO} />
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 16,
              marginTop: 32,
            }}
          >
            <BtnStyled id="edit-budget" variant="outlined" color="primary">
              <>
                <MdEdit size={20} style={{ marginRight: 10 }} />
                Editar Orçamento
              </>
            </BtnStyled>
            <BtnSecondaryStyled
              id="export-budget"
              variant="contained"
              color="secondary"
            >
              <>
                <MdDownload size={20} style={{ marginRight: 10 }} />
                Exportar orçamento
              </>
            </BtnSecondaryStyled>
          </div>
        </div>
        <DefaultPageStyled>
          <TableContainer id="budgets-table" component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Item
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Descrição
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Und.
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Qtd.
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Valor unitário (R$)
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Total orçado
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Peso orçado (%)
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Total executado
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Peso executado (%)
                  </TableCellHeaderStyled>
                  <TableCellHeaderStyled style={{ fontSize: '12px' }}>
                    Finalizado
                  </TableCellHeaderStyled>
                </TableRow>
              </TableHead>
              <TableBody>
                {MOCK_BUDGETS.map((item) => (
                  <>
                    <TableRowBodyStyled className="primary-item">
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.item_num}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.description}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.items_attributes.length === 0 && item.unit}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.items_attributes.length === 0 && item.quantity}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.items_attributes.length === 0 &&
                          item.unit_price.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.price.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.price_percentage.toFixed(2)} %
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.total_paid.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>
                        {item.paid_percentage.toFixed(2)} %
                      </TableCell>
                      <TableCell align="center">
                        {item.items_attributes.length === 0 && (
                          <Checkbox
                            disabled
                            color="deafult"
                            checked={item.is_finalized}
                          />
                        )}
                      </TableCell>
                    </TableRowBodyStyled>

                    {item.items_attributes.map((subItem) => (
                      <>
                        <TableRowBodyStyled className={` secondary-item`}>
                          <TableCell style={{ fontSize: '12px' }}>
                            {item.item_num}.{subItem.item_num}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.description}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.items_attributes.length === 0 &&
                              subItem.unit}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.items_attributes.length === 0 &&
                              subItem.quantity}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.items_attributes.length === 0 &&
                              subItem.unit_price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.price.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.price_percentage.toFixed(2)} %
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.total_paid.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </TableCell>
                          <TableCell style={{ fontSize: '12px' }}>
                            {subItem.paid_percentage.toFixed(2)} %
                          </TableCell>
                          <TableCell align="center">
                            {subItem.items_attributes.length === 0 && (
                              <Checkbox
                                disabled
                                color="deafult"
                                checked={subItem.is_finalized}
                              />
                            )}
                          </TableCell>
                        </TableRowBodyStyled>

                        {subItem.items_attributes.map((tertiaryItem) => (
                          <TableRowBodyStyled className="tertiary-item">
                            <TableCell style={{ fontSize: '12px' }}>
                              {item.item_num}.{subItem.item_num}.
                              {tertiaryItem.item_num}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.description}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.unit}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.quantity}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.unit_price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.price_percentage.toFixed(2)} %
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.total_paid.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </TableCell>
                            <TableCell style={{ fontSize: '12px' }}>
                              {tertiaryItem.paid_percentage.toFixed(2)} %
                            </TableCell>
                            <TableCell align="center">
                              <Checkbox
                                disabled
                                color="deafult"
                                checked={tertiaryItem.is_finalized}
                              />
                            </TableCell>
                          </TableRowBodyStyled>
                        ))}
                      </>
                    ))}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DefaultPageStyled>
      </RootStyled>
    </Paper>
  );
}
